import { createSlice } from '@reduxjs/toolkit';

export interface ApiMethodCacheEntry {
    response: unknown;
    args: unknown;
    time: number;
}

export interface ApiMethodCacheState {
    table: Record<string, ApiMethodCacheEntry>;
}

const ApiMethodCacheSlice = createSlice({
    name: 'apiMethodCache',
    initialState: {
        table: {},
    } as ApiMethodCacheState,
    reducers: {
        setCachedResponse: (state, action) => {
            const { hash, response, args } = action.payload;
            state.table[hash] = {
                response,
                args,
                time: Date.now(),
            };
        },
    },
});

export default ApiMethodCacheSlice;
export const ApiMethodCacheActions = ApiMethodCacheSlice.actions;
export const ApiMethodCacheSelector = (store: { apiMethodCache: ApiMethodCacheState }): ApiMethodCacheState =>
    store.apiMethodCache;
import { createSlice } from '@reduxjs/toolkit';

export interface ApiMethodCacheEntry {
    response: unknown;
    args: unknown;
    time: number;
}

export interface ApiMethodCacheState {
    table: Record<string, ApiMethodCacheEntry>;
}

const ApiMethodCacheSlice = createSlice({
    name: 'apiMethodCache',
    initialState: {
        table: {},
    } as ApiMethodCacheState,
    reducers: {
        setCachedResponse: (state, action) => {
            const { hash, response, args } = action.payload;
            state.table[hash] = {
                response,
                args,
                time: Date.now(),
            };
        },
    },
});

export default ApiMethodCacheSlice;
export const ApiMethodCacheActions = ApiMethodCacheSlice.actions;
export const ApiMethodCacheSelector = (store: { apiMethodCache: ApiMethodCacheState }): ApiMethodCacheState =>
    store.apiMethodCache;
